export function copyTextToClipboard(text, callback, errorCallback) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text, callback, errorCallback);
    return;
  }

  navigator.clipboard.writeText(text).then(
    function () {
      if (callback) callback();
    },
    function (error) {
      if (errorCallback) errorCallback(error);
    },
  );
}

function fallbackCopyTextToClipboard(text, callback, errorCallback) {
  var textArea = document.createElement('textarea');
  textArea.value = text;
  // No keyboard popping up on a phone.
  textArea.setAttribute('readonly', '');

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  // Copying from an open dialog (a bottom sheet): the dialog keeps the focus within itself and
  // would take it back from a field outside, leaving nothing selected to copy.
  var active = document.activeElement;
  var host = (active && active.closest && active.closest('.v-dialog__content')) || document.body;

  host.appendChild(textArea);
  textArea.focus();
  textArea.select();
  // iOS ignores select() alone.
  textArea.setSelectionRange(0, text.length);

  try {
    var successful = document.execCommand('copy');
    if (callback && successful) callback();
    if (errorCallback && !successful) errorCallback();
  } catch (error) {
    if (errorCallback && !successful) errorCallback(error);
  }

  host.removeChild(textArea);
}

export function isClipboardSupported() {
  return navigator.clipboard !== undefined || isActionSupported();
}

function isActionSupported(action = ['copy']) {
  const actions = typeof action === 'string' ? [action] : action;
  let support = !!document.queryCommandSupported;

  actions.forEach((action) => {
    support = support && !!document.queryCommandSupported(action);
  });

  return support;
}
